import { render, staticRenderFns } from "./OrderTypesSelect.vue?vue&type=template&id=ac34243a&scoped=true&"
import script from "./OrderTypesSelect.vue?vue&type=script&lang=js&"
export * from "./OrderTypesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac34243a",
  null
  
)

/* custom blocks */
import block0 from "./OrderTypesSelect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports